import { environment } from '../environments/environment'
import * as Rollbar from 'rollbar'

const rollbarConfig: Rollbar.Configuration = {
  enabled: environment.env !== 'dev', // Don't emit when developing on local
  accessToken: '0108c1018bf748aabd30ce00a92e6652',
  captureUncaught: true,
  captureUnhandledRejections: true,
  payload: {
    environment: environment.env,
    server: {
      root: 'webpack:///./',
    },
    client: {
      javascript: {
        source_map_enabled: true, // true by default

        // -- Add this into your configuration ---
        code_version: 'b133d5678fb84cf45076de93401a0446feb4b171',
        // ---------------------------------------

        // Optionally have Rollbar guess which frames the error was
        // thrown from when the browser does not provide line
        // and column numbers.
        guess_uncaught_frames: true,
      },
    },
  },
}

export function rollbarFactory() {
  return new Rollbar(rollbarConfig)
}
